import { Input } from "../../../components/ui/input";
import { Label } from "../../../components/ui/label";

export const fmtUsd = (v) => `$${Number(v || 0).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
export const fmtDate = (v) => (v ? new Date(v).toLocaleString("tr-TR", { dateStyle: "short", timeStyle: "short" }) : "—");
export const toMaybeNumber = (v) => (v === "" || v === null || v === undefined ? null : Number(v));

const STATUS_STYLES = {
    active: "bg-emerald-500/15 text-emerald-300 border-emerald-500/30",
    completed: "bg-emerald-500/15 text-emerald-300 border-emerald-500/30",
    credited: "bg-emerald-500/15 text-emerald-300 border-emerald-500/30",
    pending: "bg-amber-500/15 text-amber-300 border-amber-500/30",
    confirming: "bg-amber-500/15 text-amber-300 border-amber-500/30",
    suspended: "bg-red-500/15 text-red-300 border-red-500/30",
    rejected: "bg-red-500/15 text-red-300 border-red-500/30",
    disabled: "bg-red-500/15 text-red-300 border-red-500/30",
    cancelled: "bg-white/10 text-muted-foreground border-white/15",
};

export function StatusBadge({ value, testid }) {
    const cls = STATUS_STYLES[value] || "bg-white/10 text-muted-foreground border-white/15";
    return (
        <span data-testid={testid} className={`inline-flex px-2 py-0.5 rounded-md border text-[11px] font-mono uppercase tracking-wide ${cls}`}>
            {value || "—"}
        </span>
    );
}

export function Section({ title, subtitle, children, testid, action }) {
    return (
        <section data-testid={testid} className="bg-card border border-white/[0.07] rounded-2xl p-5 space-y-4">
            <div className="flex items-start justify-between gap-3">
                <div>
                    <h3 className="font-display font-semibold text-lg">{title}</h3>
                    {subtitle && <p className="text-xs text-muted-foreground mt-0.5">{subtitle}</p>}
                </div>
                {action}
            </div>
            {children}
        </section>
    );
}

export function Field({ label, hint, children }) {
    return (
        <div className="space-y-1.5">
            <Label className="text-xs text-muted-foreground">{label}</Label>
            {children}
            {hint && <p className="text-[11px] text-muted-foreground/80">{hint}</p>}
        </div>
    );
}

export function NumField({ label, value, onChange, testid, placeholder = "boş = otomatik", hint }) {
    return (
        <Field label={label} hint={hint}>
            <Input type="number" step="0.01" value={value ?? ""} onChange={(e) => onChange(e.target.value)} data-testid={testid} placeholder={placeholder} className="bg-background border-white/10 h-9" />
        </Field>
    );
}

export function StatCard({ label, value, sub, testid, accent }) {
    return (
        <div data-testid={testid} className="bg-card border border-white/[0.07] rounded-2xl p-4">
            <p className="text-[11px] font-mono uppercase tracking-wider text-muted-foreground">{label}</p>
            <p className={`font-display font-bold text-xl mt-1 ${accent || ""}`}>{value}</p>
            {sub && <p className="text-[11px] text-muted-foreground mt-0.5">{sub}</p>}
        </div>
    );
}

export function EmptyRow({ colSpan, text = "Kayıt yok." }) {
    return (
        <tr>
            <td colSpan={colSpan} className="p-8 text-center text-sm text-muted-foreground">{text}</td>
        </tr>
    );
}
